import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { UserEnum } from "../../types/userEnum";
import EntityTable from "../EntityTable";
import { extractUserEnumEditLink } from "../entitiesReferences/InternalEntityLink";
import { renderRowUpdateAction } from "../../common/TableUtils";
import { MRT_ColumnDef } from "material-react-table";
import useUserEnumQuery from "../../hooks/query/useUserEnumQuery";
import userEnumColumns, {
  userEnumFilterSpec,
} from "../../common/entities/UserEnumColumns";
import useServerFilters from "../../hooks/useServerFilters";

interface UserEnumTableProps {
  columns?: MRT_ColumnDef<UserEnum, any>[];
  filters?: Partial<UserEnum>;
  enableRowActions?: boolean;
}

const UserEnumTable: React.FC<UserEnumTableProps> = ({
  columns = userEnumColumns,
  filters = {},
  enableRowActions = true,
}) => {
  const navigate = useNavigate();

  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, userEnumFilterSpec);
  const { useFetchAll } = useUserEnumQuery();
  const { data, isLoading, errorMessage } = useFetchAll({
    filters: serverFilters,
    externalPagination: pagination,
    externalSetPagination: setPagination,
  });

  const renderRowActions = useMemo(
    () =>
      renderRowUpdateAction((userEnum: UserEnum) =>
        navigate(extractUserEnumEditLink(userEnum))
      ),
    [navigate]
  );

  return (
    <EntityTable
      loading={isLoading}
      error={errorMessage}
      columns={columns}
      renderRowActions={renderRowActions}
      enableRowActions={enableRowActions}
      enableRowSelection={false}
      data={data?.data || []}
      pagination={pagination}
      manualPagination={true}
      onPaginationChange={setPagination}
      totalRowCount={data?.total || 0}
      manualFiltering
      {...entityTableFilterProps}
    />
  );
};

export default UserEnumTable;
